const iconStroke = '#b00020'

export function IconQuotePricing() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path
        d="M24 11L34 15V24.5C34 30.2 29.6 34.8 24 36.5C18.4 34.8 14 30.2 14 24.5V15L24 11Z"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <path
        d="M20.5 23.5L23 26L28.5 20.5"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function IconQuoteDelivery() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path
        d="M8 10H6V32H30"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="8" y="14" width="18" height="14" rx="1.5" stroke={iconStroke} strokeWidth="2.2" />
      <path
        d="M26 20H34L40 26V28H26V20Z"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <circle cx="14" cy="32" r="3" stroke={iconStroke} strokeWidth="2.2" />
      <circle cx="34" cy="32" r="3" stroke={iconStroke} strokeWidth="2.2" />
      <path d="M42 18L44 16" stroke={iconStroke} strokeWidth="2.2" strokeLinecap="round" />
      <path d="M42 22H45" stroke={iconStroke} strokeWidth="2.2" strokeLinecap="round" />
      <path d="M42 26L44 28" stroke={iconStroke} strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  )
}

export function IconQuoteQuality() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <circle cx="24" cy="22" r="10" stroke={iconStroke} strokeWidth="2.2" />
      <path
        d="M24 32V38L18 40L20 34L14 30L20.5 29L24 24L27.5 29L34 30L28 34L30 40L24 38V32Z"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinejoin="round"
      />
      <path
        d="M21 22L23.5 24.5L28 20"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function IconInquirySupport() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <circle cx="18" cy="18" r="4" stroke={iconStroke} strokeWidth="2.2" />
      <circle cx="30" cy="18" r="4" stroke={iconStroke} strokeWidth="2.2" />
      <path
        d="M10 34C10 28.5 13.5 25 18 25C20.5 25 22.5 26.2 24 28"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M38 34C38 28.5 34.5 25 30 25C27.5 25 25.5 26.2 24 28"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <circle cx="24" cy="14" r="3.5" stroke={iconStroke} strokeWidth="2.2" />
      <path d="M24 17.5V20" stroke={iconStroke} strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  )
}

export function IconInquiryPartnerships() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <path
        d="M14 24C14 19.5 17 17 20 17C22 17 23.5 18 24.5 19.5"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M34 24C34 19.5 31 17 28 17C26 17 24.5 18 23.5 19.5"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M17 27L21 23L24 26L27 23L31 27"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M21 23V31" stroke={iconStroke} strokeWidth="2.2" strokeLinecap="round" />
      <path d="M27 23V31" stroke={iconStroke} strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  )
}

export function IconInquiryResponse() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" aria-hidden="true">
      <circle cx="24" cy="24" r="12" stroke={iconStroke} strokeWidth="2.2" />
      <path d="M24 14V24L30 28" stroke={iconStroke} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M36 10C38 12 39.5 14.5 40 17"
        stroke={iconStroke}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path d="M40 10V17H33" stroke={iconStroke} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const contactFormIntroIcons = {
  pricing: IconQuotePricing,
  delivery: IconQuoteDelivery,
  quality: IconQuoteQuality,
  support: IconInquirySupport,
  partnerships: IconInquiryPartnerships,
  response: IconInquiryResponse,
}
